<template>
  <div class="to-buy">
    <div class="goods-box">
      <div class="goods-image">
        <img :src="goods" />
      </div>
      <div class="goods-msg">
        <div class="goods-name">
          J-DIRECT BOX
          <label>S10</label>
        </div>
        <div class="goods-description">
          日本VPNルｰタｰ内蔵SmartTV BOX
        </div>
        <div class="price-area">
          <div class="new-price">
            <label>金额</label>
            <span>USD</span>
            <input class="priceinput" v-model="price" />
            <!-- price -->
          </div>
        </div>
        <div class="goods-logistics">
          <label>備考</label>
          <br/>
          <el-input
            type="textarea"
            style="width:370px"
            :rows="3"
            v-model="details">
          </el-input>
        </div>
        <button
          class="to-buy-btn"
          @click="toBuy()"
        >今すぐ買う</button>
      </div>

    </div>
    <div class="goods-details">
      <div class="goods-details-title">
        <span style="float:left;">
        J-direct BOX 標準販売価額$158/台、販促価額$128/台
        </span>
        <span style="float:right;font-size: 13px;">
          貨幣単位:USD
        </span>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="{background:'#39D8CC',color:'#000000'}"
          :row-class-name="tableRowClassName">
          <el-table-column
            prop="num"
            align="center"
            label="購入台数">
          </el-table-column>
          <el-table-column
            prop="rate"
            align="center"
            label="OFF率">
          </el-table-column>
          <el-table-column
            prop="forehead"
            align="center"
            label="価額">
          </el-table-column>
          <el-table-column
            prop="profit"
            align="center"
            label="販売利益">
          </el-table-column>
          <el-table-column
            prop="pricing"
            align="center"
            label="定価利益">
          </el-table-column>
        </el-table>
      </div>
      <div class="goods-foot-title">
        <span style="float:left;">
        ※ 各代理店はモデム機器を最大2台まで購入可能です。
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { goods } from '../../../images/buy/index'
export default {
  data () {
    return {
      goods,
      num: 1,
      price: '',
      details: '',
      tableData:[
        {'num':'10-50台','rate':'30%','forehead':'$89.60','profit':'$38.40','pricing':'$68.40'},
        {'num':'51-100台','rate':'40%','forehead':'$76.80','profit':'$51.20','pricing':'$81.20'},
        {'num':'101-500台','rate':'45%','forehead':'$70.40','profit':'$57.60','pricing':'$67.60'},
      ]
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      console.log(rowIndex)
      if (rowIndex === 1) {
        return 'warning-row';
      }
      return '';
    },
    toBuy () {
      let data = {
        goodsMsg: [
          {
            name: 'J-DIRECT BOX S10',
            price: this.price,
            image: goods,
            details: this.details
          }
        ],
        address: {}
      }
      localStorage.setItem('orderMsg', JSON.stringify(data))
      this.$emit('toBuy')
    },
    getproduct () {
      this.$axios({
         method:'post',
         url:'http://203.85.72.1/forcecms_zhongyin20180515/h5/product',//http://192.168.3.32:8086/forcecms_zhongyin/
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:{ kind : 5 }
      }).then((res)=>{
        console.log(res.data.data)
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.to-buy {
  width: 100%;
  padding-top: 45px;
  min-width: 1100px;
}
.goods-box {
  width: 1100px;
  margin: 0 auto;
  display: flex;
}
.goods-image {
  width: 550px;
  margin-right: 40px;
}
.goods-image img {
  display: block;
  width: 435px;
  border: 2px solid #e4e4e4;
}
.goods-msg {
  width: 550px;
}
.goods-name {
  font-size: 35px;
  font-weight: bold;
  color: #39d8cc;
}
.goods-name label {
  font-weight: normal;
  font-size: 20px;
}
.goods-description {
  font-weight: normal;
  font-size: 25px;
  color: #828282;
}
.goods-msg div {
  margin: 10px 0;
}
.price-area {
  font-size: 20px;
  box-sizing: border-box;
  padding: 10px 10px 10px 0;
}
.price-area label,
.goods-logistics label,
.goods-num label {
  color: #828282;
  font-size: 20px;
  width: 50px;
  display: inline-block;
}
.price {
  font-size: 20px;
}
.new-price {
  font-size: 20px;
  color: #FF9D01;
}
.new-price span {
  font-size: 32px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FF9D01;
  line-height: 16px;
}
.goods-logistics {
  font-size: 20px;
}
.goods-num {
  font-size: 20px;
}
.to-buy-btn {
  width: 240px;
  height: 63px;
  background: #39d8cc;
  box-shadow: 0px 1px 22px 0px rgba(4, 208, 193, 0.56);
  border-radius: 6px;
  text-align: center;
  font-size: 30px;
  color: #fff;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.1s;
}
.to-buy-btn:active {
  background: #3efaec;
}
.goods-details {
  width: 1096px;
  margin: 0 auto;
  margin-top: 50px;
  box-sizing: border-box;
  padding: 30px;
  border: solid 2px #e4e4e4;
  margin-bottom: 50px;
  background: #F3F4F4;;
}
.goods-details-title {
  font-size: 22px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #010101;
  line-height: 60px;
}
.goods-foot-title{
  font-size: 15px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #000000;
  margin-top: 26px;
  margin-bottom: 39px;
}
.details-title {
  font-size: 25px;
  margin-top: 20px;
  font-weight: bold;
  color: #222;
}
.details-msg {
  color: #828282;
  font-size: 25px;
}
.details-msg span {
  display: inline-block;
  margin: 0px 30px;
}
.goods-num input {
  font-size: 25px;
  width: 80px;
  outline: none;
  margin-right: 20px;
}
.warning-row { 
  background: #E4FFFD;
}
.priceinput{
  width: 183px;
  height: 27px;
  border: 1px solid #FF9D01;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FF9D01;
  padding: 5px 15px;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/agentBuy/modules/to-buy.vue